<template>
  <tbody v-if="Object.keys(transaction).length !== 0">
    <tr>
      <td style="width: 55px">
        <font-awesome-icon v-if="transaction.open === true"
          title="Match Process not yet complete."
          class="fa-lg has-text-warning"
          :icon="['fas', 'exclamation-triangle']"
        />
      </td>
      <td class="">
        <div class="is-flex flex-direction--column">
          <div class="is-flex">
            <router-link
              v-if="hasModule('DRMCH:MATCH:HISTORY:VIEW')"
              :to="{ path: `/directMatch/transactions/${this.transaction.id}/details` }"
              class="has-text-weight-bold">
              {{ transaction.id }}
            </router-link>
            <div v-else class="has-text-weight-bold">
              {{ transaction.id }}
            </div>
          </div>
          <div class="is-flex has-text-grey">
            {{ transaction.matchType.description }}
          </div>
        </div>
      </td>
      <td>
        <span class="has-text-weight-bold">
          {{ transaction.program.description }}
        </span>
      </td>
      <td class="is-hidden-touch">
        <div class="is-flex flex-direction--column">
          <div>
            <router-link
              :to="{ name: 'DmDistrictInfoDetails', params: { code: transaction.districtCode }}"
              class="has-text-weight-bold has-text-primary" style="font-size:14px">
              {{ transaction.district.location.name }}
            </router-link>
            <span class="padding-left--small has-text-grey">
              ({{ transaction.districtCode }})
            </span>
          </div>
          <div v-if="transaction.school">
            <router-link
              :to="{
                name: 'DmSchoolInfoDetails',
                params: {
                  districtCode: transaction.districtCode,
                  schoolCode: transaction.schoolCode,
                },
              }"
              class="is-italic">
              {{ transaction.school.location.name }}
            </router-link>
            <span class="padding-left--small has-text-grey is-italic">
              ({{ transaction.schoolCode }})
            </span>
          </div>
          <div v-else>
            <span class="is-italic has-text-grey">All Schools</span>
          </div>
        </div>
      </td>
      <td>
        <div class="is-flex flex-direction--column">
          <span class="is-flex has-text-weight-bold">
            {{
              new Intl.DateTimeFormat('en', {
                year:'numeric',
                month:'2-digit',
                day:'2-digit',
              })
              .format(new Date(transaction.transDate))
            }}
          </span>
          <span class="has-text-grey">
            {{
              new Intl.DateTimeFormat('en', {
                hour:'numeric',
                minute:'numeric',
              })
              .format(new Date(transaction.transDate))
            }}
          </span>
        </div>
      </td>
      <td>
        <router-link
          v-if="hasModule('DRMCH:MATCH:HISTORY:VIEW')"
          :to="{ path: `/directMatch/batch/${transaction.dmBatchId}/details` }"
          class="has-text-weight-bold">
          {{ transaction.dmBatchId }}
        </router-link>
        <span v-else class="has-text-weight-bold">
          {{ transaction.dmBatchId }}
        </span>
      </td>
      <td class="is-hidden-mobile">
        <dm-status-info-icon
          :matchStatus="transaction.dmTransStatus"
        />
      </td>
      <td>
        <div class="is-flex flex-justify--end flex-align--center">
          <es-loader v-if="reloading" size="2x"/>
          <a class="is-hidden-mobile" v-else-if="isInternalAction" @click="handleInternalCall">
            {{ action.text }}
          </a>
          <router-link class="is-hidden-mobile" v-else-if="!action.isHidden" :to="action.link">
            {{ action.text }}
          </router-link>
          <a class="padding-left--1rem" v-if="transactionCompletedMenu.length">
            <es-menu :setValues="transactionCompletedMenu"/>
          </a>
        </div>
      </td>
    </tr>
  </tbody>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import DmStatusInfoIcon from '@/components/DmStatusInfoIcon.vue';
import EsLoader from '@/components/EsLoader.vue';
import EsMenu from '@/components/EsMenu.vue';
import PermissionManager from '@/mixins/PermissionManager';

export default {
  mixins: [
    PermissionManager,
  ],
  props: [
    'trans',
  ],
  components: {
    DmStatusInfoIcon,
    EsLoader,
    EsMenu,
  },
  data() {
    return {
      reloading: null,
      transaction: null,
    };
  },
  created() {
    this.transaction = this.trans;
  },
  computed: {
    menuItems() {
      const items = [];
      if (['1', '2', '4', '13', '14', '15', '16', '17'].includes(this.transaction.dmTransStatus.code)) {
        items.push({
          id: 0,
          description: 'Download',
          path: `/directMatch/transactions/${this.transaction.id}/download`,
          isHidden: this.hasModule('DRMCH:DWNLD:DOWNLOAD'),
        });
      }
      if (['2'].includes(this.transaction.dmTransStatus.code)) {
        if(this.transaction.dmBatchId) {
          items.push({
            id: 1,
            description: 'Resolve',
            path: `/directMatch/nearMatches?dmMatchTransId=${this.transaction.id}&dmBatchId=${this.transaction.dmBatchId}`,
            isHidden: this.hasModule('DRMCH:MATCH:RESOLVENM:VIEW'),
          });
        } else {
          items.push({
            id: 1,
            description: 'Resolve',
            path: `/directMatch/nearMatches?dmMatchTransId=${this.transaction.id}`,
            isHidden: this.hasModule('DRMCH:MATCH:RESOLVENM:VIEW'),
          });
        }
      }
      items.push({
        id: 2,
        description: 'View Transaction Details',
        path: `/directMatch/transactions/${this.transaction.id}/details`,
        isHidden: this.hasModule('DRMCH:MATCH:HISTORY:VIEW'),
      });
      return items;
    },
    transactionCompletedMenu() {
      return this.menuItems.filter(item => item.isHidden);
    },
    action() {
      if (['10', '99'].includes(this.transaction.dmTransStatus.code)) {
        return {
          link: `/directMatch/transactions/${this.transaction.id}/details`,
          text: 'View',
          isHidden: !this.hasModule('DRMCH:MATCH:HISTORY:VIEW'),
        };
      }
      if (['2'].includes(this.transaction.dmTransStatus.code)) {
        if (this.transaction.dmBatchId) {
          return {
            link: `/directMatch/nearMatches?dmMatchTransId=${this.transaction.id}&dmBatchId=${this.transaction.dmBatchId}`,
            text: 'Resolve',
            isHidden: !this.hasModule('DRMCH:MATCH:RESOLVENM:VIEW'),
          };
        } else {
          return {
            link: `/directMatch/nearMatches?dmMatchTransId=${this.transaction.id}`,
            text: 'Resolve',
            isHidden: !this.hasModule('DRMCH:MATCH:RESOLVENM:VIEW'),
          };
        }
      }
      return {
        isHidden: true,
      };
    },
    isInternalAction() {
      return !!this.action.isInternal;
    },
  },
  methods: {
    handleInternalCall() {
      this[this.action.internalAction]();
    },
    async refreshTransactionRow() {
      try {
        this.reloading = true;
        const res = await axios.get(`directmatch/transactions/${this.transaction.id}`);
        this.transaction = res.data;
      } catch (e) {
        // handle error
      }
      this.reloading = false;
    },
  },
};
</script>

<style lang="sass" scoped>
  .padding-left--small
    padding-left: 0.25rem
  .padding-left--1rem
    padding-left: 1rem
</style>
